import { ActivePaidSubscription, RecurringPayment } from '../interfaces/active-paid-subscription';
import { ActivePaidSubscriptionDto, RecurringPaymentDto } from '../interfaces/active-paid-subscription-dto';

export class ActivePaidSubscriptionDataMapper {
  public decode(dto: ActivePaidSubscriptionDto | null): ActivePaidSubscription | null {
    if (!dto) {
      return null;
    }

    return {
      id: dto.id,
      tournamentId: dto.ownerId, // заменяем ownerId на tournamentId
      activeFrom: dto.activeFrom,
      activeTo: dto.activeTo,
      // recurringPayment: this.mapRecurringPayment(dto.recurringPayment),
      purchaseType: dto.purchaseType,
    };
  }

  private mapRecurringPayment(dto: RecurringPaymentDto | null): RecurringPayment | null {
    if (!dto) {
      return null;
    }

    return {
      id: dto.id,
      nextPayDate: dto.nextPayDate,
      period: dto.period,
    };
  }
}
